import { render } from "./aio-login-media.vue?vue&type=template&id=455462cc&scoped=true"
import script from "./aio-login-media.vue?vue&type=script&lang=js"
export * from "./aio-login-media.vue?vue&type=script&lang=js"

import "./aio-login-media.vue?vue&type=style&index=0&id=455462cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455462cc"]])

export default __exports__